import React from 'react';
import { Box, Button, Link, Heading } from '@chakra-ui/react';

import useLang from '@/hooks/useLang';
import { useImaginationRoom } from '@invitato/imagination-room';

import { YOUTUBE_LINK } from '@/constants';
import { DEFAULT_BUTTON_PROPS } from '@/constants/colors';
import { ID_YOUTUBE_SECTION } from '@/constants/identifier';
import { BG_LIVESTREAM } from '@/constants/assets';

import txt from './locales';
import { TEXT_PROPS } from '@/constants/default-props';

function YoutubeLiveSection() {
  const { onGetFinalContent } = useImaginationRoom();
  const defaultLang = useLang();
  const LANG = defaultLang;

  return (
    <Box name={ID_YOUTUBE_SECTION}>
      <Box
        width="100%"
        height="280px"
        background={`url(${onGetFinalContent('BG_LIVESTREAM', BG_LIVESTREAM)})`}
        bgSize="cover"
        bgPosition="center"
        display="flex"
        flexDir="column"
        justifyContent="center"
        alignItems="center"
        boxShadow="inset 0 0 0 2000px rgb(0 0 0 /20%)"
      >
        <Heading {...TEXT_PROPS.heading} color="alternativeColorText" marginBottom="8px">
          {txt.title[LANG]}
        </Heading>
        <Link href={YOUTUBE_LINK} target="_blank">
          <Button
            {...DEFAULT_BUTTON_PROPS}
            fontSize="18px"
            padding="16px 30px"
            _hover={{
              opacity: 0.8,
            }}
          >
            {txt.open[LANG]}
          </Button>
        </Link>
      </Box>
    </Box>
  );
}

export default React.memo(YoutubeLiveSection);
